import BaseApi from './BaseApi';

class MedicalPrescriptionApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'managers/prescription-files';
  }
}

export default MedicalPrescriptionApi;
